"use strict";

require('firebase/storage');

// Object.defineProperty(exports, "__esModule", { value: true });
let toExport = {};

/*
  // CSV
  const data = 'data:text/csv;charset=utf-8,' + csv;

  // EXCEL
  const data = 'data:application/vnd.ms-excel;base64,' + base64;
 */
toExport.download = function (data, filename, type) {
  let file = new Blob([data], {type: type});
  if (window.navigator.msSaveOrOpenBlob) // IE10+
    window.navigator.msSaveOrOpenBlob(file, filename);
  else { // Others
    let a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
};

toExport.urlToDataURL = async function (url) {
  return new Promise((resolve)=>{
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width =this.width;
      canvas.height =this.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(this, 0, 0);
      resolve(canvas.toDataURL("image/jpeg"));
    };
    img.src = url;
  });
}

// Problema com cors, utilize urlToDataURL
toExport.urlToDataURL2 = async function (url){
  return new Promise((resolve)=>{
    const xhr = new XMLHttpRequest();
    xhr.open('get', url);
    xhr.responseType = 'blob';
    xhr.onload = function(){
      const fr = new FileReader();
      fr.onload = function(){
        resolve(this.result);
      };
      fr.readAsDataURL(xhr.response); // async call
    };
    xhr.send();
  });
}


module.exports = toExport;

